// The payload wraps the identifier in an object: synapse requires a record, never a bare primitive.
export type SubjectTypeArchivedPayload = {
	subjectTypeId: number;
};

export type SubjectTypeArchivedAction = {
	type: 'SUBJECT_TYPE_ARCHIVED';
	payload: SubjectTypeArchivedPayload;
	accountId: number;
};

export default (payload: SubjectTypeArchivedPayload, accountId: number): SubjectTypeArchivedAction => ({
	type: 'SUBJECT_TYPE_ARCHIVED',
	payload,
	accountId,
});
